import React, { useCallback } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ForumEntry } from 'data/ForumEntry'
import _ from 'lodash'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'
import numeral from 'numeral'
import { useStyles } from './styles'

const DEFAULT_DISPLAY_NAME = `User ${_.random(9999)}`

interface ForumPostProps {
    entry: ForumEntry
    upvoteHandler?: (entry: ForumEntry) => void
    userId?: string
    readonly?: boolean
}

const ForumPost: React.FC<ForumPostProps> = ({ entry, upvoteHandler = () => {}, userId = '', readonly }) => {
    const classes = useStyles()

    const displayName = entry.user && entry.user.displayName ? entry.user.displayName : DEFAULT_DISPLAY_NAME

    const voteCount = numeral(entry.upvoteUsers.length)
    const upvote = useCallback(() => upvoteHandler(entry), [entry, upvoteHandler])

    return (
        <div className={classes.entryRow}>
            <div>
                <p className={classes.entry}>{entry.body}</p>
                <div className={classes.entryAuthor}>
                    <span className={classes.entryName}>{displayName}</span>
                </div>
            </div>
            <div className={classes.upvote}>
                <button className={classes.upvoteBtn} {...(!readonly && { onClick: upvote })}>
                    <FontAwesomeIcon
                        icon={faCaretUp}
                        className={entry.upvoteUsers.includes(userId) ? classes.upVoteBlue : classes.upVoteGrey}
                        size="2x"
                    />
                </button>
                <span className={classes.voteCount}>{voteCount.format(voteCount.value() > 999 ? '0.0a' : '0')}</span>
            </div>
        </div>
    )
}

export default React.memo(ForumPost)
